<template>
  <div>

    <TheHeader/>

    <section class="generic" v-if="!isLoading && getTotal > 99">

      <h1>Košík</h1>

      <h2>Položky</h2>

      <div class="content">

        <div class="row" v-for="(item, index) in cart" :key="index+item">

          <img
              width="175px"
              alt="Produkt."
              :src="getImageUrl(`product/small/${getItem(item).photo[0].file}`)"
          />

          <div class="description">
            <h3
                @click="goProduct({id: getItem(item).id})"
                :key="index+item">
              {{ getItem(item).name }}
            </h3>

            <div>{{ getItem(item).dimension }} cm</div>
            <div>{{ getItem(item).material }}</div>
            <div
                v-for="(note, index) in getItem(item).note"
                :key="index"
            >
              {{ note }}
            </div>

            <div class="price">{{ getAmount(item) * getItem(item).price }} CZK</div>

          </div>

          <div class="button">
            <a href="#" title="Odebrat." @click="removeProduct(item)">
              ODEBRAT
            </a>
          </div>

        </div>
      </div>

      <h2>Poštovné je 99 CZK.</h2>

      <h2>Celkem: {{ getTotal }} CZK.</h2>

      <h2>Doručovací adresa</h2>

      <form>
        <label v-bind:class="{ error: this.formError['firstName'] }">
          Křestní jméno
          <input type="text" name="firstName" v-model="mFirstName"/>
          <span v-if="this.formError['firstName']" class="note">
            {{ this.formError["firstName"] }}
          </span>
        </label>
        <label v-bind:class="{ error: this.formError['surname'] }">
          Příjmení
          <input type="text" name="surname" v-model="mSurname"/>
          <span v-if="this.formError['surname']" class="note">
            {{ this.formError["surname"] }}
          </span>
        </label>
        <label v-bind:class="{ error: this.formError['eMail'] }">
          E-mail
          <input type="email" name="eMail" v-model="mEMail"/>
          <span v-if="this.formError['eMail']" class="note">
            {{ this.formError["eMail"] }}
          </span>
        </label>
        <label v-bind:class="{ error: this.formError['phone'] }">
          Telefon
          <input type="text" name="phone" v-model="mPhone"/>
          <span v-if="this.formError['phone']" class="note">
            {{ this.formError["phone"] }}
          </span>
        </label>
        <label v-bind:class="{ error: this.formError['street'] }">
          Ulice
          <input type="text" name="street" v-model="mStreet"/>
          <span v-if="this.formError['street']" class="note">
            {{ this.formError["street"] }}
          </span>
        </label>
        <label v-bind:class="{ error: this.formError['city'] }">
          Město
          <input type="text" name="city" v-model="mCity"/>
          <span v-if="this.formError['city']" class="note">
            {{ this.formError["city"] }}
          </span>
        </label>
        <label v-bind:class="{ error: this.formError['postalCode'] }">
          PSČ
          <input type="text" name="postalCode" v-model="mPostalCode"/>
          <span v-if="this.formError['postalCode']" class="note">
            {{ this.formError["postalCode"] }}
          </span>
        </label>
        <label v-bind:class="{ error: this.formError['note'] }">
          Poznámka
          <textarea
              name="note"
              rows="4"
              cols="50"
              v-model="mNote"
          ></textarea>
          <span v-if="this.formError['note']" class="note">
            {{ this.formError["note"] }}
          </span>
        </label>

        <p v-if="this.formStatus === -1" class="status red">
          Zkontrolujte chyby.
        </p>
        <p v-if="this.formStatus === 1" class="status green">
          Odesláno úspěšně - shrnutí Vám příjde do schránky. Následně Vám zašleme fakturu a podklady k platbě.
        </p>
      </form>

      <a class="button green" @click="submit">Odeslat</a>

    </section>

    <section class="generic" v-if="!isLoading && getTotal === 99">
      <h1>Košík je smutný a prázdný ...</h1>
    </section>

    <TheFooter/>
  </div>
</template>

<script>
import TheFooter from "@/components/TheFooter.vue";
import TheHeader from "@/components/TheHeader";

export default {
  name: "Cart",
  components: {
    TheHeader,
    TheFooter
  },
  data() {
    return {
      mFirstName: "",
      mSurname: "",
      mEMail: "",
      mPhone: "",
      mStreet: "",
      mCity: "",
      mPostalCode: "",
      mNote: "",

      formError: [],

      isLoading: true,
      error: null,

      isSubmitting: false,
      formStatus: 0,

      item: []
    }
  },
  beforeCreate: function () {
    document.body.id = 'cart';
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const apiUrl = "/data";
      fetch(`${apiUrl}/catalogue.json`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      })
          .then(response => response.json())
          .then(json => {
            console.log("API - catalogue.");

            // data definition
            let data = json;
            console.log(json);

            if (!data.error) {
              this.item = data.data;
              this.isLoading = false;
            }
            if (data.error) {
              console.log("Error.");
            }
          })
          .catch(error => {
            console.error("Error:", error);
          });
    },
    getItem(id) {
      id = parseInt(id);

      let item = ''
      item = this.item.filter((row) => {

        // id comes from url as string
        // convert first to use ===
        if (row.id == id) {
          return true;
        }
        return false;
      });

      return item[0];
    },
    goProduct(_item) {
      this.$router.push({
        name: 'product',
        params: {
          id: _item.id
        }
      });
    },
    getAmount(id) {
      return this.storeCart.filter((currentValue) => currentValue == id).length;
    },
    removeProduct(id) {
      let localStorage = window.localStorage;

      let storeCart = localStorage.getItem('storeCart');
      storeCart = storeCart ? JSON.parse(storeCart) : [];

      //id = parseInt(id);
      storeCart = storeCart.filter(item => item !== id);

      localStorage.setItem('storeCart', JSON.stringify(storeCart));

      // reload as localStorage is hard to watch - not computed property
      // need to reload cart
      this.$router.go(0);
    },
    submit: function () {
      this.formError = [];

      this.formStatus = 0;
      this.isSubmitting = true;

      const apiUrl = "https://katerinahorak.cz/api/";
      //const apiUrl = "http://localhost:9999/api/";

      let cartToSend = [];

      this.cart.forEach((item) => {
        cartToSend.push({
          id: item,
          amount: this.getAmount(item),
          name: this.getItem(item).name,
          total: this.getItem(item).price * this.getAmount(item)
        });
      });

      console.log(cartToSend);

      let data = "";
      data = {
        firstName: this.mFirstName,
        surname: this.mSurname,
        eMail: this.mEMail,
        phone: this.mPhone,
        street: this.mStreet,
        city: this.mCity,
        postalCode: this.mPostalCode,
        note: this.mNote,
        order: cartToSend
      };

      fetch(`${apiUrl}shop/order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      })
          .then(response => response.json())
          .then(json => {
            console.log("API - shop/order.");

            // data definition
            let data = json;
            console.log(json);

            if (!data.error) {
              this.formStatus = 1;

              // reset

              this.mFirstName = "";
              this.mSurname = "";
              this.mEMail = "";
              this.mPhone = "";
              this.mStreet = "";
              this.mCity = "";
              this.mPostalCode = "";
              this.mNote = "";

              let localStorage = window.localStorage;
              localStorage.removeItem('storeCart');

            }
            if (data.error) {
              this.formStatus = -1;
              console.log("Error.");
              for (let [key, value] of Object.entries(data.error)) {
                console.log(`${key}: ${value}`);

                this.$set(this.formError, key, value);
              }
            }
            this.isSubmitting = false;
          })
          .catch(error => {
            console.error("Error:", error);
          });
    },
  },
  computed: {
    storeCart() {
      let localStorage = window.localStorage;

      let storeCart = localStorage.getItem('storeCart');
      storeCart = storeCart ? JSON.parse(storeCart) : [];

      return storeCart;
    },
    cart() {
      let localStorage = window.localStorage;

      let storeCart = localStorage.getItem('storeCart');
      storeCart = storeCart ? JSON.parse(storeCart) : [];

      // get id of unique product in array
      let toReturn =
          storeCart.filter((currentValue, index, arr) =>
              arr.indexOf(currentValue) === index);

      // how many times is product in array
      // console.log(storeCart.filter((currentValue) => currentValue == 2).length);

      return toReturn;
    },
    getTotal() {

      // 99 CZK cause postage
      let total = 99;

      const storeCart = this.storeCart;
      console.log(storeCart);

      // for every single item in raw cart add it's price to total
      storeCart.forEach((item) => {
        item = parseInt(item);
        total = total + parseInt(this.getItem(item).price);
      });

      return total;
    },
    removeFromCart(id) {
      let localStorage = window.localStorage;

      let storeCart = localStorage.getItem('storeCart');
      storeCart = storeCart ? JSON.parse(storeCart) : [];

      console.log(storeCart.filter((currentValue) => currentValue != id));

      return true;
    }
  }
};
</script>
